import { DTFilter } from "./dt-filter";

export class RequestFilter extends DTFilter {
    public type: number;
    public programName: string;
    public personName: string;
    public email: string;
}



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/models/common/request-filter.ts